import _fragmentPageIndustryDetailTemplate from './_fragment-page-industry-detail-template'

const pageContentType = 'PageIndustrySubscriptionPayments'

export default _fragmentPageIndustryDetailTemplate(pageContentType)
